<template>
    <div class="mainCont">
        <div class="upperContent">
            <div>
                <span><strong class="serialNumberStronger">SERIAL NUMBER:</strong> {{ container.serialNumber }}</span>
                
            </div>
            <div class="capacityCont">
                <strong>{{ container.capacity }}</strong>
            </div>
        </div>
        <div class="lowerContent">
            <p>
                <span class="garbClsSpan">GARBAGE CLASS: </span>
                <img v-if="container.garbageClass == 'organic'" src="@/assets/scenarios/garbage/container/organic.png" width="20px" height="20px">
                <img v-if="container.garbageClass == 'plastic'" src="@/assets/scenarios/garbage/container/plastic.png" width="20px" height="20px">
                <img v-if="container.garbageClass == 'paper'" src="@/assets/scenarios/garbage/container/paper.png" width="20px" height="20px">
            </p>
            <div>
                <button class="moreBtn" v-on:click="showMore()">VIEW DETAILS</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ContainerDetail',
    props: {
        container: {
            type: Object,
            required: true
        }
    },
    mounted() {
    },
    methods: {
        showMore() {
            this.$store.commit('setContainerDetail', this.container);
            this.$router.push({ path: '/scenarios/iiot/containers/' + this.container.serialNumber });
        }
    }
}
</script>
<style>
.mainCont {
    width: 100%;
    background-color: #25262D;
    display: grid;
    place-items: center;
    color: white;
    min-height: 100px;
}

.upperContent {
    display: grid;    
    grid-template-columns: auto auto;
    justify-content: space-between;
    width: 100%;
    padding: 10px;
    vertical-align: middle;
    margin-bottom: 1rem;
}

.serialNumberStronger {
    font-weight: 500;
}

.capacityCont {
    display: grid;
    place-items: center;
    width: 65px;
    height: 35px;
    background-color: #7EA53F;
    color: #25262D;
    font-weight: 500;
    border-radius: 5px;
    margin: 5px;
}

.lowerContent {
    display: grid;
    grid-template-columns: auto auto;
    justify-content: space-between;
    width: 100%;
    padding: 0 10px;
    vertical-align: middle;
    position: sticky;
}
.garbClsSpan {
    font-weight: 500;
    font-size: 0.7rem;
}

.moreBtn {
    background-color: #D9D9D9;
    border-radius: 12px;
    padding: 0 1rem;
    color: #2E3038;
    font-weight: 700;
}
</style>